export default "__VITE_ASSET__44cb55a3__"